import React from "react";
import { HttpStatusCode } from "axios";

import { logout } from "../../../services/authServices";
import { reactivateMember } from "../../../services/memberServices";

import useSimplePopup from "../../../hooks/useSimplePopup";
import useFullScreenLoading from "../../../hooks/useFullScreenLoading";

import CommonPopup from "..";
import HorizontalRule from "../../Rule/Horizontal";
import CommonButton from "../../Button";

import DormancyBlueCheck from "../../../assets/img/dormancy-blue-check.png";

type Props = {
  popup?: string;
  email?: string;
  dormancyDate?: string;
  onClose?: () => void;
};

export default function DormancyPopup({
  popup,
  email,
  dormancyDate,
  onClose,
}: Props) {
  const [isLoading, setIsLoading] = React.useState(false);
  const loadingComponent = useFullScreenLoading({ isLoading });
  const [simplePopupComponent, { open }] = useSimplePopup({});

  return (
    <>
      <CommonPopup
        title="휴면 회원 해제 안내"
        isOpen={popup === "dormancy"}
        unUseHorizonRule
        padding={0}
      >
        {loadingComponent}
        <div className="p-5 pt-0 flex flex-col gap-5 items-center">
          <div className="flex flex-col gap-[25px] items-center">
            <div className="h-[80px]">
              <img src={DormancyBlueCheck} alt="check" className="h-[80px]" />
            </div>
            <div className="w-[306px] text-xl font-medium text-center">
              회원님의 계정이 1년간 로그인하지 않아 휴면회원 전환 상태 에요.
            </div>
          </div>

          <div className="w-full">
            <HorizontalRule margin="0" className="border-brand-neutral-15" />
            <div className="pt-5 flex gap-2.5 w-full">
              <div className="flex flex-col gap-1.5 flex-1 items-center">
                <div className="font-semibold">{email}</div>
                <div className="text-brand-neutral-50">로그인한 게정</div>
              </div>
              <div className="flex flex-col gap-1.5 flex-1 items-center">
                <div className="font-semibold">{dormancyDate}</div>
                <div className="text-brand-neutral-50">휴면 전환일</div>
              </div>
            </div>
          </div>

          <div className="px-2.5 py-5 text-center bg-brand-weather-badge-background rounded-[3px] text-brand-neutral-80 whitespace-pre-line w-full">
            {
              "정보통신망 이용촉진 및 정보보호 등에 관한 법률에\n의거하여 1년간 접속하지 않으신 회원님들의\n개인정보가 휴면처리 상태로 전환됩니다."
            }
          </div>
        </div>
        <div className="flex">
          <CommonButton
            variant="grey"
            className="w-[170px] h-bottom-button rounded-none font-medium"
            onClick={() => {
              logout();
              onClose?.();
            }}
          >
            로그아웃
          </CommonButton>
          <CommonButton
            className="h-bottom-button flex-1 rounded-none font-medium"
            onClick={async () => {
              setIsLoading(true);
              try {
                const res = await reactivateMember();
                if (res.status === HttpStatusCode.Ok) {
                  open("휴면 해제에 성공했습니다.\n로그인해주세요.");
                } else {
                  open("휴면 해제에 실패했습니다.\n관리자에게 문의해주세요.");
                }
              } catch (e: any) {
                if (e?.response?.data?.error) {
                  open(e?.response?.data?.error?.replace(". ", ".\n"));
                } else {
                  open("휴면 해제에 실패했습니다.\n관리자에게 문의해주세요.");
                }
              } finally {
                setIsLoading(false);
                onClose?.();
              }
            }}
          >
            휴면 해제하기
          </CommonButton>
        </div>
      </CommonPopup>
      {simplePopupComponent}
    </>
  );
}
